import React from "react";
import styled, { css } from "styled-components";

export const HistoryNavigatorStyle = styled.div`
  text-align: center;
  padding: 15px 15px 5px;
  & > .wrapper {
    width: 100%;
    background-color: #eee;
    border-radius: 5px;
    padding: 3px;
    display: flex;
    flex-flow: wrap row;
    align-items: stretch;
    height: 40px;
    line-height: 34px;
  }
  & .button {
    flex: 1;
    font-weight: 500;
    text-align: center;
    border-radius: 4px;
    line-height: inherit;
    color: #4b4b4b;
    transition: 0.4s;
  }
  & .button:not(:last-child) {
    margin-left: 5px;
  }
`;
